<ion-toolbar class="main-header-toolbar">
    <app-header></app-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content" *transloco="let t; read: 'studyHistory'">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">

        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->
    <ion-grid fixed class="grid-md">

        <ion-row class="white-bg-wrapper">
            <ion-col size="12" class="ion-justify-content-start">
                <div class="top-wrapper">
                    <div class="back" [routerLink]="'/home'">
                        <img alt="back" src="assets/images/icons/arrow_left_green.svg"/>
                        {{ 'btnBack'|transloco }}
                    </div>

                    <div class="page-title">
                        <div class="title-wrapper">
                            {{ t('title') }}

                            <div class="info" (click)="openModal('achievement')">

                                <img src="assets/images/icons/info24x24.svg" alt="info">
                            </div>
                        </div>


                        <button class="btn btn-primary english-levels" *ngIf="groupedByYear===null"
                                (click)="openEnglishLevelModal()">  {{ t('englishLevel') }}
                        </button>
                    </div>


                    <div class="info" *ngIf="!showCertificatesDummy">
                        <button class="btn btn-primary english-levels" *ngIf="groupedByYear!=null"
                                (click)="openEnglishLevelModal()">{{ t('englishLevel') }}
                        </button>

                        <app-tabs *ngIf="groupedByYear">
                            <app-tab [tabTitle]="year" [active]="activeTabs[year]" *ngFor="let year of uniqueYears">
                                <div class="tab-content">
                                    <ion-grid class="ion-no-padding ion-no-margin">

                                        <ion-col size="12" class="item-wrapper">

                                            <div class="history-wrapper">
                                                <app-certificate class="certificate"
                                                                 *ngFor="let group of groupedByYear[year]"
                                                                 [group]="group"></app-certificate>

                                            </div>


                                        </ion-col>

                                    </ion-grid>
                                </div>
                            </app-tab>

                        </app-tabs>
                    </div>

                </div>


            </ion-col>

        </ion-row>

        <ion-row class="white-bg-wrapper with-margin-top" *ngIf="showCertificatesDummy">
            <ion-col size="12" class="ion-justify-content-start">

                <div class="info">
                    <button class="btn btn-primary english-levels" *ngIf="groupedByYear!=null"
                            (click)="openEnglishLevelModal()">{{ t('englishLevel') }}
                    </button>

                    <app-dummy [type]="'study_history'" [isImageSmall]="true"></app-dummy>

<!--                    <img [src]="'assets/images/' + this.lang + '/dummies/study_history.png'" alt="not study history yet">-->

                </div>
            </ion-col>


        </ion-row>


    </ion-grid>
    <app-footer></app-footer>

</ion-content>
<app-chats></app-chats>
